/** @internal */
export const enum AudioSubNode {
    ANALYZER = "Analyzer",
    STEREO = "Stereo",
    SPATIAL = "Spatial",
    VOLUME = "Volume",
}
